module.exports = __webpack_public_path__ + "img/1534806584.b025ceca.jpg";